import React, {useMemo} from 'react'
import Text from '@component/Text/Text'
import UseQueryNotification from '@hook/query/account/useQueryNotification'
import useQueryGetNotificationCount from '@hook/query/account/notification/useQueryGetNotificationCount'
import {INavNotification} from '@api/user/account/notification/getNotification'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

interface IProps {
    className?: string
}

const NotificationCount: React.FC<IProps> = ({className}) => {
    const {data: me} = useQueryFetchMe(undefined, false)
    const {data: notificationPages} = UseQueryNotification(me?.id)
    const {data: notificationCount} = useQueryGetNotificationCount()

    const notificationList = useMemo(() => {
        let list: INavNotification[] = []
        notificationPages?.pages?.map(page => page?.map(item => list.push(item)))
        return list
    }, [notificationPages])

    return (
        <>
            {notificationList.find(item => item.is_read === false) && notificationCount > 0 && (
                <div
                    className={`absolute bottom-0 md:bottom-[-4px] left-[15px] h-[14px] min-h-[14px] bg-red_shade dark:bg-dark_red_shade px-[4px] rounded-[7px] ${className}`}>
                    <Text className={'text-white text-ti4 leading-[14px] text-center relative window:top-[0px]'}>
                        {notificationCount}
                    </Text>
                </div>
            )}
        </>
    )
}

export default NotificationCount
